import { Currency as WebServicesCurrency } from '@ps/isp-web-services-types';
import { Currency as CoreCurrency } from '@ps/web-core-enums';

export const webServicesCurrencyToCoreCurrencyMap: Record<WebServicesCurrency, CoreCurrency> = {
  [WebServicesCurrency.ARS]: CoreCurrency.ArgentinePeso,
  [WebServicesCurrency.AUD]: CoreCurrency.AustralianDollar,
  [WebServicesCurrency.BYR]: CoreCurrency.BelarusianRuble,
  [WebServicesCurrency.BRL]: CoreCurrency.BrazilianReal,
  [WebServicesCurrency.GBP]: CoreCurrency.BritishPound,
  [WebServicesCurrency.BGN]: CoreCurrency.BulgarianLev,
  [WebServicesCurrency.CAD]: CoreCurrency.CanadianDollar,
  [WebServicesCurrency.CLP]: CoreCurrency.ChileanPeso,
  [WebServicesCurrency.CNY]: CoreCurrency.ChineseYuan,
  [WebServicesCurrency.COP]: CoreCurrency.ColombianPeso,
  [WebServicesCurrency.HRK]: CoreCurrency.CroatianKuna,
  [WebServicesCurrency.CZK]: CoreCurrency.CzechKoruna,
  [WebServicesCurrency.DKK]: CoreCurrency.DanishKrone,
  [WebServicesCurrency.EEK]: CoreCurrency.EstonianKroon,
  [WebServicesCurrency.EUR]: CoreCurrency.Euro,
  [WebServicesCurrency.HUF]: CoreCurrency.HungarianForint,
  [WebServicesCurrency.ISK]: CoreCurrency.IcelandicKrona,
  [WebServicesCurrency.INR]: CoreCurrency.IndianRupee,
  [WebServicesCurrency.JPY]: CoreCurrency.JapaneseYen,
  [WebServicesCurrency.KZT]: CoreCurrency.KazakhstaniTenge,
  [WebServicesCurrency.LVL]: CoreCurrency.LatvianLats,
  [WebServicesCurrency.LTL]: CoreCurrency.LithuanianLitas,
  [WebServicesCurrency.MXN]: CoreCurrency.MexicanPeso,
  [WebServicesCurrency.MDL]: CoreCurrency.MoldovanLeu,
  [WebServicesCurrency.MNT]: CoreCurrency.MongolianTugrik,
  [WebServicesCurrency.TWD]: CoreCurrency.NewTaiwanDollar,
  [WebServicesCurrency.NZD]: CoreCurrency.NewZealandDollar,
  [WebServicesCurrency.NOK]: CoreCurrency.NorwegianKrone,
  [WebServicesCurrency.PYG]: CoreCurrency.ParaguayanGuarani,
  [WebServicesCurrency.PEN]: CoreCurrency.PeruvianSol,
  [WebServicesCurrency.PHP]: CoreCurrency.PhilippinePeso,
  [WebServicesCurrency.PFF]: CoreCurrency.PlayMoney,
  [WebServicesCurrency.PLN]: CoreCurrency.PolishZloty,
  [WebServicesCurrency.RON]: CoreCurrency.RomanianLeu,
  [WebServicesCurrency.RUB]: CoreCurrency.RussianRuble,
  [WebServicesCurrency.RSD]: CoreCurrency.SerbianDinar,
  [WebServicesCurrency.SKK]: CoreCurrency.SlovakKoruna,
  [WebServicesCurrency.ZAR]: CoreCurrency.SouthAfricanRand,
  [WebServicesCurrency.SEK]: CoreCurrency.SwedishKrona,
  [WebServicesCurrency.CHF]: CoreCurrency.SwissFranc,
  [WebServicesCurrency.THB]: CoreCurrency.ThaiBaht,
  [WebServicesCurrency.USD]: CoreCurrency.USDollar,
  [WebServicesCurrency.UAH]: CoreCurrency.UkrainianHryvnia,
  [WebServicesCurrency.UYU]: CoreCurrency.UruguayanPeso
};
